/**
 * 컬렉션·보유 한도 (2026-08-28 전수조사 확정 — FN-021 · FN-027 · FN-029 · FN-032).
 *
 *   · 수량 1~999 — 999 에서 '+' 비활성, 직접 입력 초과분은 999 로 클램프
 *   · 컬렉션 최대 50개(Favorites 포함) — 도달 시 '새 컬렉션' 비활성
 *   · 컬렉션당 최대 500장 — 도달 시 담기 비활성 + 안내
 *
 * ⚠ 화면에서만 막는다. 서버도 같은 값으로 거른다(개발) — 여기 숫자를 바꾸면
 *   서버와 어긋나므로 문서(FN-032)부터 고친다.
 */
export const QTY_MAX = 999;
export const COLLECTION_MAX = 50;
export const COLLECTION_CARD_MAX = 500;

export function clampQty(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(QTY_MAX, Math.max(1, Math.trunc(value)));
}
